import { ChartAreaInteractive } from "@/components/chart-area-interactive";
import { DataTable } from "@/components/data-table";
import { SiteHeader } from "@/components/site-header";
import { StatisticsCard } from "@/components/statistics-card";
import { MonetaryStatisticsCard } from "@/components/monetary-statistics-card";
import { TimeRangeSelector } from "@/components/time-range-selector";
import { adminProvider } from "@/providers/admin.provider";
import { countersProvider } from "@/providers/counters.provider";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import data from "@/app/dashboard/data.json";

export function DashboardPage() {
  const [days, setDays] = useState(365);

  const { data: onlineUsers, isLoading: loadingOnline } = useQuery({
    queryKey: ["admin-users-current"],
    queryFn: () => adminProvider.getUsersCurrent(),
    refetchInterval: 10_000,
    staleTime: 5_000,
  });

  const { data: usersHistory, isLoading: loadingHistory } = useQuery({
    queryKey: ["admin-users-history", days],
    queryFn: () => adminProvider.getUsersHistory(days),
    staleTime: 60_000,
  });

  const { data: usersHistoryAll, isLoading: loadingHistoryAll } = useQuery({
    queryKey: ["admin-users-history-all"],
    queryFn: () => adminProvider.getUsersHistoryAll(),
    staleTime: 60_000,
  });

  const { data: distanceAggregate, isLoading: loadingDistance } = useQuery({
    queryKey: ["admin-distance-aggregate"],
    queryFn: () =>
      countersProvider.getAggregateCounters(
        "distance_traveled_by_user_meters",
      ),
    refetchInterval: 10_000,
    staleTime: 5_000,
  });

  const totalDistanceMeters = distanceAggregate?.[0]?.total ?? 0;

  return (
    <>
      <SiteHeader title="Dashboard" />
      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            {/* Time range selector */}
            <div className="px-4 lg:px-6">
              <TimeRangeSelector days={days} onDaysChange={setDays} />
            </div>

            {/* Live stat + mock cards */}
            <div className="flex flex-col gap-4">
              <StatisticsCard
                onlineUsers={onlineUsers}
                totalUsers={onlineUsers}
                loadingOnline={loadingOnline}
                usersHistory={usersHistory}
                days={days}
                allHistoryData={usersHistoryAll}
                totalDistance={totalDistanceMeters}
                loadingDistance={loadingDistance}
              />

              <MonetaryStatisticsCard days={days} />
            </div>

            {/* New registrations chart — real data, shared days state */}
            <div className="px-4 lg:px-6">
              <ChartAreaInteractive
                data={usersHistory ?? []}
                days={days}
                onDaysChange={setDays}
                isLoading={loadingHistory}
                onlineUsers={onlineUsers}
                allHistoryData={usersHistoryAll ?? []}
              />
            </div>

            <DataTable data={data} />
          </div>
        </div>
      </div>
    </>
  );
}
